import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Timer } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";

/* Topbar chip: shows the current user's running clock(s) on any page — one tap back to the card. */
export default function RunningClocks() {
  const nav = useNavigate();
  const { t } = useLang();
  const { user, hasPermission } = useAuth();
  const enabled = !!user && hasPermission("repairs.view");
  const { data = [] } = useQuery({ queryKey: ["running-mine"], queryFn: () => api.get("/repairs/running/mine").then((r) => r.data), enabled, refetchInterval: 30000 });
  if (!data.length) return null;
  const c = data[0];
  return (
    <button onClick={() => nav(`/repairs/${c.id}/mechanic`)} className="inline-flex items-center gap-2 h-9 px-3 rounded-full border border-emerald-500/40 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 text-xs font-semibold max-w-[220px]" data-testid="topbar-running-clock" title={t("clockRunning")}>
      <Timer className="h-3.5 w-3.5 animate-pulse shrink-0" />
      <span className="truncate">{c.car_plate || c.card_number}{c.note ? ` · ${c.note}` : ""}</span>
      {data.length > 1 && <span className="font-mono">+{data.length - 1}</span>}
    </button>
  );
}
